<footer class="py-3">
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-xs-12 col-md-8 col-lg-6">
        <div
          class="d-flex flex-column flex-sm-row justify-content-center justify-content-sm-start align-items-sm-center">
          <a
            class="footer-logo d-block d-sm-inline-block text-center text-sm-left mr-sm-2"
            target="_blank"
            [href]="linksService.pbUrl"
            aria-label="Pitney Bowes"></a>
          <span class="d-block d-sm-inline-block text-center text-sm-left pt-1 pb-3 p-sm-0"
            >&copy;{{ date }} {{ 'core.footer.copyright' | translate }}
          </span>
          <span class="d-block d-sm-inline-block align-items-sm-center pt-1 pb-3 p-sm-0">
            <div class="text-center">Version {{ version }}</div>
          </span>
        </div>
      </div>

      <!-- standard footer links -->
      <div class="col-xs-12 col-md-4 col-lg-6">
        <div class="d-flex justify-content-center justify-content-sm-end align-items-sm-center">
          <a class="d-block cursor-pointer" (click)="openLicenceModal()">{{ 'core.footer.licenses' | translate }}</a>
          <a
            class="d-block ml-3"
            [href]="urls.pbUrl.fr + '/mentionslegales/donneespersonnelles.html'"
            target="_blank"
            >{{ 'core.footer.term' | translate }}</a
          >
          <a class="d-block ml-3" [href]="urls.pbUrl.fr + '/mentionslegales.html'" target="_blank">{{
            'core.footer.legal' | translate
          }}</a>
        </div>
      </div>
    </div>
  </div>
</footer>
